const invoicePaymentStatusConstants = Object.freeze({
  DUE: 'DUE',
  OVERDUE: 'OVERDUE',
  PAID: 'PAID',
  PAID_OUTSIDE: 'PAID_OUTSIDE',
  PROCESSING: 'PROCESSING',
  UPCOMING: 'UPCOMING'
});

const invoiceStatusConstants = Object.freeze({
  MATCHED: 'MATCHED',
  PARSED: 'PARSED',
  PENDING: 'PENDING'
});

const invoiceTypeConstants = Object.freeze({
  INVOICE: 'INVOICE',
  NO_RECEIPT: 'NO_RECEIPT',
  RECEIPT: 'RECEIPT'
});

const invoiceMatchTypeConstants = Object.freeze({
  AUTOMATED: 'AUTOMATED',
  MANUAL: 'MANUAL',
});

export {
  invoicePaymentStatusConstants,
  invoiceStatusConstants,
  invoiceTypeConstants,
  invoiceMatchTypeConstants,
};
